function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { GetItContext } from "../../base/provider/GetItContext";
import { NodesUtil } from "../NodesUtil";
import { useSignal } from "@preact/signals-react";
import isBlank from "@sedan-utils/is-blank";
import { BrainClient } from "imagica-corekit/dist/base/api/BrainClient";
import { ErrorUtil } from "imagica-corekit/dist/base/api/ErrorUtil";
import { MessageCenter } from "imagica-corekit/dist/base/kernel/MessageCenter";
import { Analytics } from "imagica-corekit/dist/base/port/Analytics";
import { useContext } from "react";
var INDEXERS_IS_READY = "INDEXERS_IS_READY";
var ERRORTIP = "Either the engine you requested does not exist or there was another issue processing your request.";
var defaultErrorChatObj = {
  type: "Error",
  value: ERRORTIP
};
var AssistantDefaultList = ["Hello, I am an AI trained to answer questions about ", "How can I help you?"];
export var ChatInterfaceBloc = /*#__PURE__*/function () {
  function ChatInterfaceBloc(props) {
    _classCallCheck(this, ChatInterfaceBloc);
    _defineProperty(this, "getIt", useContext(GetItContext));
    _defineProperty(this, "analytics", this.getIt(Analytics));
    _defineProperty(this, "brainClient", this.getIt(BrainClient));
    _defineProperty(this, "inputText", useSignal(""));
    _defineProperty(this, "file", useSignal(""));
    _defineProperty(this, "json", useSignal({}));
    _defineProperty(this, "text", useSignal(""));
    _defineProperty(this, "file_uuid", useSignal(undefined));
    _defineProperty(this, "filename", useSignal(""));
    _defineProperty(this, "prevInput", useSignal(""));
    _defineProperty(this, "isLoading", useSignal(false));
    _defineProperty(this, "isMessageLoading", useSignal(false));
    _defineProperty(this, "chatList", useSignal([]));
    _defineProperty(this, "isStreamStopped", useSignal(true));
    _defineProperty(this, "chatHistoryVarible", useSignal([]));
    _defineProperty(this, "AssistantDefaultList", useSignal(AssistantDefaultList));
    _defineProperty(this, "textAreaValueChatList", useSignal([]));
    _defineProperty(this, "messageCenter", this.getIt(MessageCenter));
    _defineProperty(this, "isIndexers", useSignal(false));
    _defineProperty(this, "pubsub_topic", "");
    this.props = props;
  }
  _createClass(ChatInterfaceBloc, [{
    key: "refreshNodeData",
    value: function refreshNodeData() {
      this.props.onChange(_objectSpread(_objectSpread({}, this.props.textAreaValue), {}, {
        chatList: this.chatList.value,
        preQuery: this.prevInput.value,
        chatHistory: this.chatHistoryVarible.value,
        isStreamStopped: this.isStreamStopped.value
      }));
    }
  }, {
    key: "init",
    value: function init(props, isShare, isInputFoucus) {
      var _props$textAreaValue, _props$textAreaValue2, _props$textAreaValue4, _props$textAreaValue6, _props$textAreaValue7, _props$textAreaValue8, _props$textAreaValue9, _props$textAreaValue10;
      this.json.value = (_props$textAreaValue = props.textAreaValue) === null || _props$textAreaValue === void 0 ? void 0 : _props$textAreaValue.json;
      if (_typeof((_props$textAreaValue2 = props.textAreaValue) === null || _props$textAreaValue2 === void 0 ? void 0 : _props$textAreaValue2.file) === "object") {
        var _props$textAreaValue3;
        this.json.value = (_props$textAreaValue3 = props.textAreaValue) === null || _props$textAreaValue3 === void 0 ? void 0 : _props$textAreaValue3.json;
      }
      if (typeof ((_props$textAreaValue4 = props.textAreaValue) === null || _props$textAreaValue4 === void 0 ? void 0 : _props$textAreaValue4.file) === "string") {
        var _props$textAreaValue5;
        this.file.value = (_props$textAreaValue5 = props.textAreaValue) === null || _props$textAreaValue5 === void 0 ? void 0 : _props$textAreaValue5.file;
      }
      this.text.value = (_props$textAreaValue6 = props.textAreaValue) === null || _props$textAreaValue6 === void 0 ? void 0 : _props$textAreaValue6.text;
      if (NodesUtil.isEmpty(this.file.value) && NodesUtil.isEmpty(this.json.value) && NodesUtil.isEmpty(this.text.value)) return;
      this.pubsub_topic = (_props$textAreaValue7 = props.textAreaValue) === null || _props$textAreaValue7 === void 0 ? void 0 : _props$textAreaValue7.pubsub_topic;
      this.file_uuid.value = (_props$textAreaValue8 = props.textAreaValue) === null || _props$textAreaValue8 === void 0 ? void 0 : _props$textAreaValue8.file_uuid;
      this.AssistantDefaultList.value = this.getAssistantDefaultList((_props$textAreaValue9 = props.textAreaValue) === null || _props$textAreaValue9 === void 0 ? void 0 : _props$textAreaValue9.filename);
      if (!isShare && !NodesUtil.isEmpty((_props$textAreaValue10 = props.textAreaValue) === null || _props$textAreaValue10 === void 0 ? void 0 : _props$textAreaValue10.chatList)) {
        var _props$textAreaValue11, _props$textAreaValue12, _props$textAreaValue13, _props$textAreaValue14, _props$textAreaValue15;
        this.chatList.value = ((_props$textAreaValue11 = props.textAreaValue) === null || _props$textAreaValue11 === void 0 ? void 0 : _props$textAreaValue11.chatList) || [];
        this.prevInput.value = ((_props$textAreaValue12 = props.textAreaValue) === null || _props$textAreaValue12 === void 0 ? void 0 : _props$textAreaValue12.preQuery) || "";
        this.chatHistoryVarible.value = ((_props$textAreaValue13 = props.textAreaValue) === null || _props$textAreaValue13 === void 0 ? void 0 : _props$textAreaValue13.chatHistory) || [];
        this.textAreaValueChatList.value = ((_props$textAreaValue14 = props.textAreaValue) === null || _props$textAreaValue14 === void 0 ? void 0 : _props$textAreaValue14.chatList) || [];
        this.isStreamStopped.value = (_props$textAreaValue15 = props.textAreaValue) === null || _props$textAreaValue15 === void 0 ? void 0 : _props$textAreaValue15.isStreamStopped;
      } else {
        this.prevInput.value = "";
        if (!isInputFoucus) {
          /** 排除掉输入换行执行到这儿 导致文本被清空的问题*/
          this.inputText.value = "";
        }
        this.chatHistoryVarible.value = [];
        this.chatList.value = [];
        this.isLoading.value = false;
        this.textAreaValueChatList.value = [];
      }
      this.refreshNodeData();
    }
  }, {
    key: "getAssistantDefaultList",
    value: function getAssistantDefaultList(filename) {
      this.AssistantDefaultList.value = AssistantDefaultList;
      var arr = _toConsumableArray(this.AssistantDefaultList.value);
      arr[0] = arr[0] + filename + ".";
      return arr;
    }
  }, {
    key: "postIndexers",
    value: function () {
      var _postIndexers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(query) {
        var isIndexers, baseData, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isIndexers = this.isIndexers.value;
              baseData = {
                query: query,
                loader: "PDFReader"
              };
              if (isBlank(this.text.value)) {
                _context.next = 6;
                break;
              }
              data = _objectSpread(_objectSpread({}, baseData), {}, {
                text: this.text.value
              });
              _context.next = 16;
              break;
            case 6:
              if (isBlank(this.file.value)) {
                _context.next = 10;
                break;
              }
              data = _objectSpread(_objectSpread({}, baseData), {}, {
                file: this.file.value
              });
              _context.next = 16;
              break;
            case 10:
              if (isBlank(this.json.value)) {
                _context.next = 14;
                break;
              }
              data = _objectSpread(_objectSpread({}, baseData), {}, {
                json: this.json.value
              });
              _context.next = 16;
              break;
            case 14:
              console.error("missing params: ", this.text.value, this.json.value, this.file.value);
              throw "missing params";
            case 16:
              _context.prev = 16;
              _context.next = 19;
              return this.brainClient.openAi.indexers({
                mode: "chat",
                data: data,
                chat_history: !NodesUtil.isEmpty(this.chatHistoryVarible.value) ? this.chatHistoryVarible.value : undefined,
                uuid: this.file_uuid.value
              });
            case 19:
              return _context.abrupt("return", _context.sent);
            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](16);
              if (!(isIndexers === true)) {
                _context.next = 28;
                break;
              }
              return _context.abrupt("return", Promise.resolve(_context.t0));
            case 28:
              return _context.abrupt("return", new Promise(function () {}));
            case 29:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[16, 22]]);
      }));
      function postIndexers(_x) {
        return _postIndexers.apply(this, arguments);
      }
      return postIndexers;
    }()
  }, {
    key: "stockRequest",
    value: function stockRequest() {
      var _this = this;
      return new Promise(function (resolve) {
        if (_this.isIndexers.value === false) {
          // Wait for websocketResponse
          var timer = setInterval(function () {
            if (_this.isIndexers.value === true) {
              clearInterval(timer);
              resolve(INDEXERS_IS_READY);
            }
          }, 2000);
        }
      });
    }
  }, {
    key: "pollingRequest",
    value: function pollingRequest(query) {
      var _this2 = this;
      return Promise.race([this.stockRequest(), this.postIndexers(query)]).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(res) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!(res === INDEXERS_IS_READY)) {
                  _context2.next = 4;
                  break;
                }
                _context2.next = 3;
                return _this2.postIndexers(query);
              case 3:
                return _context2.abrupt("return", _context2.sent);
              case 4:
                return _context2.abrupt("return", res);
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "onPressEnter",
    value: function () {
      var _onPressEnter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result, errorText;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(NodesUtil.isEmpty(this.inputText.value) || this.isMessageLoading.value)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              this.isMessageLoading.value = true;
              this.analytics.logEvent("chat_user_input", {
                chat_user_input: this.inputText.value
              });
              _context3.prev = 4;
              this.chatList.value = [].concat(_toConsumableArray(this.chatList.value), [{
                type: "User",
                value: this.inputText.value
              }]);
              this.prevInput.value = this.inputText.value;
              _context3.next = 9;
              return this.pollingRequest(this.inputText.value);
            case 9:
              result = _context3.sent;
              this.inputText.value = "";
              if (!(result.isSuccess === false)) {
                _context3.next = 13;
                break;
              }
              throw result.errorDescription;
            case 13:
              this.chatHistoryVarible.value = result.data.data.chat_history;
              this.analytics.logEvent("chat_ai_response", {
                chat_ai_response: result.data.data.response
              });
              this.chatList.value = [].concat(_toConsumableArray(this.chatList.value), [{
                type: "Assistant",
                value: result.data.data.response
              }]);
              /// 添加数据后，开始数据流动画
              this.isStreamStopped.value = false;
              _context3.next = 23;
              break;
            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3["catch"](4);
              errorText = typeof _context3.t0 === "string" ? _context3.t0 : ErrorUtil.defaultErrorMsg;
              this.chatList.value = [].concat(_toConsumableArray(this.chatList.value), [_objectSpread(_objectSpread({}, defaultErrorChatObj), {}, {
                value: errorText
              })]);
            case 23:
              this.isMessageLoading.value = false;
              this.refreshNodeData();
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 19]]);
      }));
      function onPressEnter() {
        return _onPressEnter.apply(this, arguments);
      }
      return onPressEnter;
    }()
  }, {
    key: "onRegenerate",
    value: function () {
      var _onRegenerate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var arr, last, result, newObj, errorText;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!NodesUtil.isEmpty(this.chatList.value)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              _context4.prev = 2;
              arr = _toConsumableArray(this.chatList.value);
              last = arr.pop();
              if (last) {
                this.analytics.logEvent("click_chat_regenerate", {
                  chat_regenerate: last.value
                });
              }
              this.chatList.value = arr;
              this.isMessageLoading.value = true;
              _context4.next = 10;
              return this.postIndexers(this.prevInput.value);
            case 10:
              result = _context4.sent;
              if (!(result.isSuccess === false)) {
                _context4.next = 13;
                break;
              }
              throw result.errorDescription;
            case 13:
              newObj = {
                type: "Assistant",
                value: result.data.data.response
              };
              this.chatList.value = [].concat(_toConsumableArray(this.chatList.value), [newObj]);
              /// 添加数据后，开始数据流动画
              this.isStreamStopped.value = false;
              this.analytics.logEvent("chat_ai_response", {
                chat_ai_response: result.data.data.response
              });
              _context4.next = 23;
              break;
            case 19:
              _context4.prev = 19;
              _context4.t0 = _context4["catch"](2);
              errorText = typeof _context4.t0 === "string" ? _context4.t0 : ErrorUtil.defaultErrorMsg;
              this.chatList.value = [].concat(_toConsumableArray(this.chatList.value), [_objectSpread(_objectSpread({}, defaultErrorChatObj), {}, {
                value: errorText
              })]);
            case 23:
              _context4.prev = 23;
              this.isMessageLoading.value = false;
              this.refreshNodeData();
              return _context4.finish(23);
            case 27:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[2, 19, 23, 27]]);
      }));
      function onRegenerate() {
        return _onRegenerate.apply(this, arguments);
      }
      return onRegenerate;
    }()
  }, {
    key: "onReStart",
    value: function onReStart() {
      this.analytics.logEvent("click_chat_start_new");
      this.prevInput.value = "";
      this.chatHistoryVarible.value = [];
      this.chatList.value = [];
      this.refreshNodeData();
    }
  }, {
    key: "onLinkClicked",
    value: function onLinkClicked() {
      window.open("https://imagica.zendesk.com/hc/en-us/articles/18399149126171-Imagica-Terms-of-Use");
    }
  }, {
    key: "listenTopic",
    value: function listenTopic() {
      var _this3 = this;
      this.messageCenter.on(this.pubsub_topic, function () {
        _this3.isIndexers.value = true;
        _this3.messageCenter.off(_this3.pubsub_topic);
      });
    }
  }]);
  return ChatInterfaceBloc;
}();